import "magnific-popup";
import 'rangeslider.js';

class MortgageCalculator {
	constructor() {
		this.setDefaults();
		this.handleResults();
		this.doEvents();
		// this.setMarkup();
	}

	numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	setDefaults() {
		this.defaults = {
			number_of_payments: BJZM_DATA.mortgage_defaults.amortization_period * 12,
			interest_rate: (parseFloat(BJZM_DATA.mortgage_defaults.interest_rate) / 100) / 12,
			
			starting_from: 700000, /* field */
			starting_from_min: 300000, /* field */
			starting_from_max: 1000000, /* field */
			
			downpayment: 300000, /* field */
			downpayment_min: 10000, /* field */
			downpayment_max: 1000000, /* field */
		
			income: 100000, /* field */
			income_min: 10000, /* field */
			income_max: 700000, /* field */
		
			principal: 600000, /* dynamic */
			monthly_amount: -1, /* dynamic */
		}
	}

	setMarkup() {
		//console.log('this.defaults', this.defaults);
		$(".mc-data-starting_from_min").html(`$${this.numberWithCommas( this.defaults.starting_from_min) }`);
		$(".mc-data-starting_from_max").html(`$${this.numberWithCommas( this.defaults.starting_from_max) }`);
		$(".mc-data--starting-from").html( `$${this.numberWithCommas(this.defaults.starting_from)} ` );

		var percent = parseFloat(this.defaults.downpayment / this.defaults.starting_from).toFixed(2) * 100;
		var percentString = `${percent}%`;
		$(".mc-data-downpayment_min").html(`$${this.numberWithCommas( this.defaults.downpayment_min) }`);
		$(".mc-data-downpayment_max").html(`$${this.numberWithCommas( this.defaults.downpayment_max) }`);
		$(".mc-data--down-payment").html( `$${this.numberWithCommas(this.defaults.downpayment)}` );

		$(".mc-data-income_min").html(`$${this.numberWithCommas( this.defaults.income_min) }`);
		$(".mc-data-income_max").html(`$${this.numberWithCommas( this.defaults.income_max) }`);
		$(".mc-data--household-income").html( `$${this.numberWithCommas(this.defaults.income)} ` );

		var monthly_amount = Math.round(this.defaults.monthly_amount);
		$(".m-calculator__total").html(`$${this.numberWithCommas(monthly_amount)} `);
	}

	calculateValues() {
		this.defaults.principal = this.defaults.starting_from - this.defaults.downpayment;
		this.defaults.downpayment_max = this.defaults.starting_from;
		this.defaults.monthly_amount = this.calculateMonthlyAmount();
	}

	calculateMonthlyAmount() {
		var top = this.defaults.interest_rate * ( Math.pow( 1 + this.defaults.interest_rate, this.defaults.number_of_payments ) );
		var bottom = ( Math.pow( 1 + this.defaults.interest_rate, this.defaults.number_of_payments ) ) - 1;
		var total = this.defaults.principal * ( top / bottom );
		return total;
	}

	handleResults() {
		this.calculateValues();
		this.setMarkup();
	}

	doEvents() {
		$('.open-m-calculator').magnificPopup({
			type:'inline',
			removalDelay: 300,
			mainClass: 'mfp-img-mobile mfp-fade',
		});

		var self = this;
		
		/*the following will automatically open the calculator window*/
		// $.magnificPopup.open({
		//   items: {
		//     src: '#open-m-calculator'
		//   },
		//   type: 'inline'
		// });

		/*starting-from*/
		$(".m-calculator__range--starting-from").slider({
			min: self.defaults.starting_from_min,
			max: self.defaults.starting_from_max,
			value: self.defaults.starting_from,
			range: 'min',
			change: function(event, ui) {
				self.defaults.starting_from = ui.value;
				var dollars = `$${self.numberWithCommas(ui.value)} `;

				self.defaults.downpayment_max = self.defaults.starting_from;
				$(".m-calculator__range--down-payment").slider('option', 'max', self.defaults.starting_from);

				/*if starting_from is smaller than downpayment*/
				if( self.defaults.starting_from <= self.defaults.downpayment ) {
					self.defaults.downpayment = self.defaults.starting_from;

					$(".m-calculator__range--down-payment").slider('option', 'value', self.defaults.starting_from);
				}

				self.handleResults();
			}
		});

		$(".m-calculator__close-link").on('click', function(e){
			e.preventDefault();
			$('.open-m-calculator').magnificPopup('close');
		});

		/*income*/
		$(".m-calculator__range--income").slider({
			min: self.defaults.income_min,
			max: self.defaults.income_max,
			value: self.defaults.income,
			range: 'min',
			change: function(event, ui) {
				self.defaults.income = ui.value;
				var dollars = `$${self.numberWithCommas(ui.value)} `;
				self.handleResults();
			}
		});

		/*down payment*/
		$(".m-calculator__range--down-payment").slider({
			min: self.defaults.downpayment_min,
			max: self.defaults.downpayment_max,
			value: self.defaults.downpayment,
			range: 'min',
			change: function(event, ui) {
				self.defaults.downpayment = ui.value;
				var dollars = `$${self.numberWithCommas(ui.value)} `;
				self.handleResults();
			}
		});

	}

}
module.exports = MortgageCalculator;